<template>
    <svg
    style="background-color: white; border-radius: 100%;"
    :width="width"
    :height="height"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    <rect x="12" y="12" width="6" height="18" fill="#833e93" />
    <rect x="22" y="12" width="6" height="18" fill="#833e93" />
</svg>
</template>

<script>
export default {
    name: 'PauseIcon',
    props: {
        width: {
            type: String,
            default: '40',
        },
        height: {
            type: String,
            default: '40',
        },
    },
};
</script>
